
import React, { useEffect, useState } from "react";
import { Box, Checkbox, Grid, Paper, Typography } from "@mui/material";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { styled } from '@mui/material/styles';
import styles from '.././../../styles.module.css';
import { Icon } from '@iconify/react';
import { StyledTableCellPrint, StyledTableRow, } from '../../reusableComponent/StyledTable'
import convertToIndianWords from "../../reusableComponent/convertToIndianWords";


const SalesOrderPrint = ({ orderPrint, invoiceSettingList }) => {
    const printData = orderPrint;
    const invoiceSetting = invoiceSettingList && invoiceSettingList[0];

    const login_details = sessionStorage.getItem('loginUser');
    const userD = JSON.parse(login_details);
    const userInfo = userD.userInfo;

    const dateConversion = (date) => {
        var today = new Date(date);
        var dd = String(today.getDate()).padStart(2, "0");
        var mm = String(today.getMonth() + 1).padStart(2, "0");
        var yyyy = today.getFullYear();
        const convDate = dd + "/" + mm + "/" + yyyy;
        return convDate;
    };


    return (
        <>
            <Box style={{ margin: '30px' }} className="print-source">
                <Paper sx={{ margin: '55px 15px 30px 15px', boxShadow: 'none', border: '1px solid #000000', height: '90vh' }}   >
                    <Grid container sx={{}}>
                        <Grid item xs={12} sx={{ backgroundColor: '#c0c0c0' }}>
                            <Typography sx={{ textAlign: 'center', fontSize: '18px', fontWeight: 'bold', padding: '1px' }}>
                                SALES ORDER
                            </Typography>
                        </Grid>
                        <Grid item xs={12} sx={{ borderTop: '1px solid #616161' }}>
                            <Box >
                                <Grid container >
                                    <Grid item md={2} sx={{ padding: '4px', display: 'flex', justifyContent: 'center', alignItems: 'center', borderRight: '1px solid #616161' }}>
                                        <img src={userInfo.logo_image} style={{ width: '100px', height: '100px', borderRadius: '4px' }} />
                                    </Grid>
                                    <Grid item md={10} sx={{ padding: '4px 4px 4px 10px', }}>
                                        <Typography sx={{ fontSize: '24px', fontWeight: 'bold' }}>   {userInfo.company}
                                        </Typography>
                                        <Grid container sx={{}}>
                                            <Grid item xs={0.6} >
                                                <Typography className={`${styles.text_Print}`}>
                                                    <Icon icon="fa-regular:address-card" />
                                                </Typography>
                                                <Typography className={`${styles.text_Print}`}>
                                                    <Icon icon="fa-regular:address-card" color="#ffffff" />
                                                </Typography>
                                                <Typography className={`${styles.text_Print}`}>
                                                    <Icon icon="bi:telephone" />
                                                </Typography>
                                                <Typography className={`${styles.text_Print}`}>
                                                    <Icon icon="mdi-light:email" height="14px" />
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={11.4} >
                                                <Box>
                                                    <Typography className={`${styles.text_Print}`}>
                                                        {userInfo.companyAddress}
                                                    </Typography>
                                                    <Typography className={`${styles.text_Print}`}>
                                                        {userInfo.state} , {userInfo.companyPinCode}
                                                    </Typography>
                                                    <Typography className={`${styles.text_Print}`} >
                                                        {userInfo.mobileNumber}
                                                    </Typography>
                                                    <Typography className={`${styles.text_Print}`} >
                                                        {userInfo.email}
                                                    </Typography>
                                                </Box>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Box>
                        </Grid>
                        <Grid item xs={12} sx={{ borderTop: '1px solid #616161', height: '32px' }}>
                            <Grid container >
                                <Grid item xs={6} >
                                    <Grid container sx={{ padding: '4px 4px 4px 8px', }}>
                                        <Grid item xs={3} >
                                            <Typography sx={{ fontWeight: 'bold', fontSize: '16px' }}>
                                                GSTIN
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={0.5}  >
                                            <Box sx={{ textAlign: 'center' }}>
                                                <Typography sx={{ fontWeight: 'bold', fontSize: '16px' }}>:</Typography>
                                            </Box>
                                        </Grid>
                                        <Grid item xs={8.5} >
                                            <Box>
                                                <Typography sx={{ fontWeight: 'bold', fontSize: '16px', }}> {userInfo.companyGstIN}</Typography>
                                            </Box>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item xs={6} sx={{ borderLeft: '1px solid #616161' }}>
                                    <Grid container sx={{ padding: '4px 4px 4px 8px', }}>
                                        <Grid item xs={3} >
                                            <Typography sx={{ fontWeight: 'bold', fontSize: '16px' }}>
                                                PAN No
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={0.5}  >
                                            <Box sx={{ textAlign: 'center' }}>
                                                <Typography sx={{ fontWeight: 'bold', fontSize: '16px' }}>:</Typography>
                                            </Box>
                                        </Grid>
                                        <Grid item xs={8.5} >
                                            <Box>
                                                <Typography sx={{ fontWeight: 'bold', fontSize: '16px', }}> {userInfo.companyPanNo}</Typography>
                                            </Box>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={12} sx={{ borderTop: '1px solid #616161', height: '15px' }}>

                        </Grid>
                    </Grid>
                    <Grid container sx={{ marginRight: '4px', borderTop: '1px solid #616161', borderBottom: '1px solid #616161', }}>
                        <Grid item xs={6} sx={{ borderRight: '1px solid #616161', }}>
                            <Box sx={{ minHeight: '110px', padding: '6px', margin: '6px', textAlign: 'left', backgroundColor: '#ffffff' }}>
                                <Typography sx={{ fontSize: '12px', fontWeight: 'bold' }}>
                                    {printData.CNS_Name}
                                </Typography>
                                <Typography className={`${styles.text_Print}`}>
                                    {printData.address}
                                </Typography>
                                <Typography className={`${styles.text_Print}`}>
                                    {printData.state}, {printData.pinCode}
                                </Typography>
                                <Typography className={`${styles.text_Print}`}>
                                    <strong style={{ fontWeight: '500' }}>  GSTIN: </strong> {printData.gstn}
                                </Typography>
                            </Box>
                        </Grid>

                        <Grid item xs={6} sx={{}}>
                            <Box sx={{ minHeight: '110px', padding: '6px', margin: '6px', textAlign: 'left', backgroundColor: '#ffffff' }}>
                                <Grid container sx={{}}>
                                    <Grid item xs={4} >
                                        <Box sx={{}}>
                                            <Typography sx={{ fontWeight: 'bold', fontSize: '12px' }}>
                                                SALES ORDER No
                                            </Typography>
                                            <Typography className={`${styles.text_Print}`} sx={{ fontWeight: 'bold' }}>
                                                SO Date
                                            </Typography>
                                            <Typography className={`${styles.text_Print}`} sx={{ fontWeight: 'bold' }}>
                                                Quotation No
                                            </Typography>
                                            <Typography className={`${styles.text_Print}`} sx={{ fontWeight: 'bold' }}>
                                                Quotation Date
                                            </Typography>
                                        </Box >
                                    </Grid>
                                    <Grid item xs={0.5}  >
                                        <Box sx={{ textAlign: 'center' }}>
                                            <Typography sx={{ fontSize: '12px' }}>:</Typography>
                                            <Typography className={`${styles.text_Print}`}>:</Typography>
                                            <Typography className={`${styles.text_Print}`}>:</Typography>
                                            <Typography className={`${styles.text_Print}`}>:</Typography>
                                        </Box>
                                    </Grid>
                                    <Grid item xs={7.5} sx={{}}>
                                        <Box>
                                            <Typography sx={{ fontSize: '12px', fontWeight: 'bold' }}> {printData.salesOrderNo}</Typography>
                                            <Typography className={`${styles.text_Print}`}>  {dateConversion(printData.salesOrderDate)}</Typography>
                                            <Typography className={`${styles.text_Print}`}>  {printData.quatationNo == '' ? '-' : printData.quatationNo}</Typography>
                                            <Typography className={`${styles.text_Print}`}> {printData.quatationNo == '' ? '-' : dateConversion(printData.quatationDate)}</Typography>
                                        </Box>
                                    </Grid>
                                </Grid>
                            </Box>
                        </Grid>
                    </Grid>
                    <Box style={{ height: '20px' }}> </Box>
                    <>
                        <TableContainer sx={{ minWidth: 650, minHeight: 310, padding: '0px 1px 0px 1px' }}>
                            <Table size="small" style={{ borderCollapse: 'collapse' }}>
                                <TableHead>
                                    <TableRow>
                                        <StyledTableCellPrint align="left" className={`${styles.print_table_head}`} style={{ borderLeft: 'none' }} width="254">Item Description</StyledTableCellPrint>
                                        <StyledTableCellPrint align="left" className={`${styles.print_table_head}`} width="78">HSN / SAC</StyledTableCellPrint>
                                        <StyledTableCellPrint align="right" className={`${styles.print_table_head}`} width="55">Qty</StyledTableCellPrint>
                                        <StyledTableCellPrint align="right" className={`${styles.print_table_head}`} width="55">Rate</StyledTableCellPrint>
                                        <StyledTableCellPrint align="right" className={`${styles.print_table_head}`} width="55">GST <span style={{ fontSize: '8px' }}>(%) </span> </StyledTableCellPrint>
                                        <StyledTableCellPrint align="right" className={`${styles.print_table_head}`} width="110" style={{ borderRight: 'none' }}>Amount</StyledTableCellPrint>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {JSON.parse(printData && printData.childRows).map((row) => (
                                        <StyledTableRow
                                            sx={{ '&:last-child td, &:last-child th': { border: '1px solid #616161' } }} >
                                            <StyledTableCellPrint align="left" className={`${styles.print_table_body}`} style={{ borderLeft: 'none' }} width="254">
                                                {invoiceSetting.itemThroughManualEntry === 'true' ? row.itemDescription : row.itemName + ' (' + row.itemCode + ')'}
                                            </StyledTableCellPrint>
                                            <StyledTableCellPrint align="left" className={`${styles.print_table_body}`} width="78">{row.hsnCode}</StyledTableCellPrint>
                                            <StyledTableCellPrint align="right" className={`${styles.print_table_body}`} width="55">{row.quantity} {row.unit}</StyledTableCellPrint>
                                            <StyledTableCellPrint align="right" className={`${styles.print_table_body}`} width="55">{row.rate}</StyledTableCellPrint>
                                            <StyledTableCellPrint align="right" className={`${styles.print_table_body}`} width="55">{row.gst}</StyledTableCellPrint>
                                            <StyledTableCellPrint align="right" className={`${styles.print_table_body}`} style={{ borderRight: 'none' }}>{row.amount}</StyledTableCellPrint>
                                        </StyledTableRow >
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </>
                    <br />
                    <>
                        <Box style={{ height: '20px', borderTop: '1px solid #616161' }}> </Box>
                        <Box sx={{ textAlign: 'left', borderTop: '1px solid #616161' }}>
                            <Grid container >
                                <Grid item xs={8} sx={{ minHeight: '170px' }}>
                                    <Box sx={{ textAlign: 'left', }}>
                                        <Typography sx={{ fontSize: '12px', padding: '4px 4px 4px 8px' }}>
                                            Rupees {convertToIndianWords(Math.round(printData.total))} Only.
                                        </Typography>

                                    </Box>
                                </Grid>
                                <Grid item xs={4} >
                                    <Table aria-label="simple table" sx={{ borderCollapse: 'collapse', height: '190px' }}>
                                        <TableBody>
                                            <TableRow>
                                                <StyledTableCellPrint align="center" className={`${styles.print_table_body}`} style={{ borderTop: 'none', fontWeight: 'bold' }}>Basic Amount </StyledTableCellPrint>
                                                <StyledTableCellPrint align="right" width="120" className={`${styles.print_table_body}`} style={{ borderTop: 'none', borderRight: 'none' }}> {parseFloat(printData.basicTotal).toFixed(2)}</StyledTableCellPrint>
                                            </TableRow>
                                            <TableRow>
                                                <StyledTableCellPrint align="center" className={`${styles.print_table_body}`} style={{ fontWeight: 'bold' }}>GST Amount</StyledTableCellPrint>
                                                <StyledTableCellPrint align="right" width="120" className={`${styles.print_table_body}`} style={{ borderRight: 'none' }}> {parseFloat(printData.gstTotal).toFixed(2)} </StyledTableCellPrint>
                                            </TableRow>
                                            <TableRow>
                                                <StyledTableCellPrint align="center" className={`${styles.print_table_body}`} style={{ borderBottom: 'none', fontWeight: 'bold' }}>Total Amount</StyledTableCellPrint>
                                                <StyledTableCellPrint align="right" width="120" className={`${styles.print_table_body}`} style={{ borderRight: 'none', borderBottom: 'none' }}>{parseFloat(printData.total).toFixed(2)} </StyledTableCellPrint>
                                            </TableRow>
                                        </TableBody>
                                    </Table>
                                </Grid>
                            </Grid>
                            <Grid container sx={{ borderTop: '1px solid #616161' }}>
                                <Grid item xs={12} >
                                    <Box sx={{ padding: '4px 14px 4px 4px', }}>
                                        <Typography sx={{ textAlign: 'right', paddingRight: '12px', fontSize: '12px' }}>
                                            For <span style={{ fontSize: '12px', fontWeight: 'bold' }}> {userInfo.company}</span>
                                        </Typography>
                                        <br />
                                        <br />
                                        <Typography sx={{ color: '#000000', textAlign: 'right', paddingRight: '12px', fontSize: '12px' }}>
                                            Authorized Signatory
                                        </Typography>
                                    </Box>
                                </Grid>
                            </Grid>
                        </Box>
                    </>
                </Paper>
            </Box>
        </>
    )
}
export default SalesOrderPrint;

